import React, { Component } from 'react';

import { Container, Offcanvas, Row, Col,  Form } from 'react-bootstrap';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
import CommonSuggestSelect from '../components/CommonSuggestSelect';
import CommonFile from '../components/CommonFile';
import CustomDatePicker from "../components/CommonDatePicker";
import CommonButton from '../components/CommonButton';

import CommonAlert from '../components/CommonAlert';
import CommonLoadingBar from '../components/CommonLoadingBar';

/**
import CommonRadio from '../components/CommonRadio';
import CommonCheckbox from '../components/CommonCheckbox';
*/

import * as Actions from '../actions/ActionCenter';

import * as fn from '../../library/function';
import * as helper from '../../library/helper';
import * as util from '../../library/utilitys';

import SimpleBar from 'simplebar-react';

import InlineEB01DataExpensesEB01 from '../inline/InlineEB01DataExpensesEB01';
import InlineEB01DataLearningResult from '../inline/InlineEB01DataLearningResult';
import InlineEB01DataCourseBenefit from '../inline/InlineEB01DataCourseBenefit';
import InlineEB01DataTrainingDetails from '../inline/InlineEB01DataTrainingDetails';

class InputEB01DataCourse extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedDate: new Date()
        };

        this.simpleBarRef = React.createRef();
        this.approvedRef = React.createRef();
    }

    handleDateChange = (date) => { this.setState({ selectedDate: date }); };

    prepareInputs = async () => {
        const { URL, Action, Inputs, onUpdateState } = this.props;
        const isUpdateMode = Action.Mode === 'update';

        let updatedInputs = fn.setRequiredPrimaryKey(Inputs, isUpdateMode);

        onUpdateState('Inputs', updatedInputs);
    }

    componentDidUpdate = async (prevProps) => {
        if (fn.shouldPrepareInputs(prevProps.Action, this.props.Action)) {
            await this.prepareInputs();
        }

        if(prevProps.Action.Mode !== this.props.Action.Mode && this.props.Action.Mode === 'update'){
            this.autoCalculate();

            if (this.props.Approved) {
                setTimeout(() => {
                    const approvedEl = this.approvedRef?.current;
                    const simpleBarContent = this.simpleBarRef?.current?.getScrollElement?.();

                    if (approvedEl && simpleBarContent) {
                        const offsetTop = approvedEl.offsetTop;

                        simpleBarContent.scrollTo({
                            top: offsetTop,
                            behavior: 'smooth'
                        });
                    }
                }, 300); 
            }
        }
    }

    calculateTotalPeople = async () => {
        let { Inputs, onInputChange } = this.props;
        const batchCount = Number(Inputs.batch_count?.value) || 0;
        const peoplePerBatch = Number(Inputs.people_per_batch?.value) || 0;
    
        await onInputChange({ target: { name: 'total_people', value: batchCount * peoplePerBatch } }, "Inputs");        
    }

    calculateTotalBudget = async () => {
        let { Inputs, onInputChange } = this.props;
        const batchCount = Number(Inputs.batch_count?.value) || 0;
        const budgetPerBatch = Number(Inputs.budget_per_batch?.value) || 0;
    
        // console.log(batchCount, budgetPerBatch);
        
        await onInputChange({ target: { name: 'total_budget', value: batchCount * budgetPerBatch } }, "Inputs");        
    }    

    chainInputs = async (object) => {
        const { Inputs, Masterbase, onInputChange } = this.props;
        
        let element = object.target.id;

        const chainMap = {
            enterprise_id: {
                targetField: 'benefits_id',
                sourceList: Masterbase?.enterprise,
            },
        };

        const chainConfig = chainMap[element];
        if (!chainConfig) return;

        const { targetField, sourceList } = chainConfig;
        const selected = sourceList?.find(item => item.id === Inputs[element]?.value);
        const value = selected?.[targetField] || '';

        onInputChange({ target: { name: targetField, value } }, 'Inputs');
    }

    autoCalculate = async () => {
        await this.calculateTotalPeople();
        await this.calculateTotalBudget();
    }

    resetApproveCourse = async (e) => {
        let value = e.target.value;

        if(value !== '3'){
            const { Inputs, onUpdateState } = this.props;
            let updatedInputs = Inputs;

            updatedInputs.status.value = '';
            updatedInputs.office_signer_name.value = '';
            updatedInputs.office_sign_date.value = '';
            onUpdateState('Inputs', updatedInputs);    
        }    
    }

    render = () => {
        let props = this.props;

        let { App, onInputChange, onCloseAlert, onSubmit, onDiscardSubmit, onPreviewFile, onDeleteFile, onGenerateCourseCode } = props;

        let { Action, Inputs, ReadOnlys, InputGroup, Masterbase, Operation, UserCookie } = props;        

        let { Submit } = Operation;
        
        let { show, mode } = Action.OffCanvas;

        let isLoading = Action.Loading.submit;

        return (
            <Offcanvas 
                show={show}
                placement="end" 
                style={{ '--bs-offcanvas-width': '100vw' }}
                backdrop={Submit ? "static" : true}
                onHide={(e) => props.onClose(e)}
            >
                <Offcanvas.Header closeButton className="border-bottom custom-offcanvas-header">
                    <Offcanvas.Title className="custom-offcanvas-header offcanvas-title"><i className={`${App.icon} text-white me-2`}/>{App.title}</Offcanvas.Title>
                </Offcanvas.Header>

                <Offcanvas.Body className="custom-offcanvas-body">
                    
                    <CommonAlert 
                        alert={Action.Alert} 
                        
                        callback={(e) => onCloseAlert(e)}
                    />
                    
                    <SimpleBar id="inputs" className="simple-bar-input" ref={this.simpleBarRef}>

                        <Container fluid className="data-table-container">
                    
                            <Row>
                                <Col md={{ span: 10, offset: 1 }} className="eb-form-container">
                                    
                                    <Row>
                                        <Col md={12} className="d-flex align-items-center justify-content-center text-center">
                                            <h5>หลักสูตรการอบรมระยะสั้นตามแนวทางอีอีซีโมเดล</h5>
                                        </Col>
                                    </Row>

                                    <Row className="mt-3">
                                        <Col md={3} className="mb-3">{util.formatLabel('1. ', Inputs.th_name)}</Col>
                                        <Col md={9} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.th_name}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />  
                                        </Col>
                                        
                                    </Row>
                                    <Row>
                                        <Col md={3} className="d-flex align-items-center justify-content-end mb-3">{util.formatLabel('', Inputs.course_type)}</Col>
                                        <Col md={2} className="mb-3">  
                                            <CommonSelect
                                                element="Inputs"
                                                input={Inputs.course_type}
                                                option={{source: 'options', section: 'course_type', item: 'default'}}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => { 
                                                    await onInputChange(e, element);
                                                }} 
                                                disabled={!['0','1','2'].includes(UserCookie?.types)}
                                            /> 
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={3} className="mb-3">{util.formatLabel('2. ', Inputs.academy_id)}</Col>
                                        <Col md={5} className="mb-3">
                                            {/* <CommonSelect
                                                element="Inputs"
                                                input={Inputs.academy_id}
                                                option={{source: 'db', data: Masterbase?.academy}}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                                disabled={!['0','1'].includes(UserCookie?.types)}
                                            /> */}
                                            <CommonSuggestSelect
                                                element="Inputs"
                                                input={Inputs.academy_id}
                                                option={{source: 'db', data: Masterbase?.academy}}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                                disabled={!['0','1'].includes(UserCookie?.types)}
                                            />
                                        </Col>
                                        <Col md={1} className="mb-3 text-end">{util.formatLabel(null, ReadOnlys.academy_code)}</Col>
                                        <Col md={2} className="mb-3">
                                            <Form.Control
                                                type="text"
                                                id={ReadOnlys.academy_code.id}
                                                name={ReadOnlys.academy_code.id}
                                                value={
                                                    Masterbase?.academy?.find((a) => a.id === Inputs.academy_id?.value)?.academy_code || ''
                                                }
                                                placeholder={ReadOnlys.academy_code.label}
                                                disabled={true}
                                            />  
                                        </Col>
                                    </Row>   

                                    <Row>
                                        <Col md={3} className="d-flex align-items-center justify-content-end mb-3">{util.formatLabel(null, ReadOnlys.coordinator)}</Col>
                                        <Col md={2} className="mb-3">
                                            <Form.Control
                                                type="text"
                                                id={ReadOnlys.coordinator.id}
                                                name={ReadOnlys.coordinator.id}
                                                value={
                                                    Masterbase?.academy?.find((a) => a.id === Inputs.academy_id?.value)?.coordinator_name || ''
                                                }
                                                placeholder={ReadOnlys.coordinator.label}
                                                disabled={true}
                                            />
                                        </Col>
                                        <Col md={1} className="d-flex align-items-center justify-content-end mb-3">{util.formatLabel(null, ReadOnlys.coordinator_phone)}</Col>
                                        <Col md={2} className="mb-3">
                                            <Form.Control
                                                type="text"
                                                id={ReadOnlys.coordinator_phone.id}
                                                name={ReadOnlys.coordinator_phone.id}
                                                value={
                                                    Masterbase?.academy?.find((a) => a.id === Inputs.academy_id?.value)?.phone_number || ''
                                                }
                                                placeholder={ReadOnlys.coordinator_phone.label}
                                                disabled={true}
                                            />
                                        </Col>   
                                        <Col md={1} className="d-flex align-items-center justify-content-end mb-3">{util.formatLabel(null, ReadOnlys.coordinator_email)}</Col>
                                        <Col md={2} className="mb-3">
                                            <Form.Control
                                                type="text"
                                                id={ReadOnlys.coordinator_email.id}
                                                name={ReadOnlys.coordinator_email.id}
                                                value={
                                                    Masterbase?.academy?.find((a) => a.id === Inputs.academy_id?.value)?.email || ''
                                                }
                                                placeholder={ReadOnlys.coordinator_email.label}
                                                disabled={true}
                                            />
                                        </Col>
                                    </Row>   

                                    <Row>
                                        <Col md={3} className="mb-3">{util.formatLabel('3. ', Inputs.enterprise_id)}</Col>
                                        <Col md={9} className="mb-3">
                                            {/* <CommonSelect
                                                element="Inputs"
                                                input={Inputs.enterprise_id}
                                                option={{source: 'db', data: Masterbase?.enterprise}}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => { 
                                                    await onInputChange(e, element);
                                                    await this.chainInputs(e);
                                                }} 
                                            /> */}
                                            <CommonSuggestSelect
                                                element="Inputs"
                                                input={Inputs.enterprise_id}
                                                option={{source: 'db', data: Masterbase?.enterprise}}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => { 
                                                    await onInputChange(e, element);
                                                    await this.chainInputs(e);
                                                }} 
                                            />
                                        </Col>
                                    </Row>  

                                    <Row>
                                        <Col md={3} className="d-flex justify-content-end mb-3">{util.formatLabel(null, Inputs.benefits_id)}</Col>
                                        <Col md={6} className="mb-3">
                                            <CommonSelect
                                                element="Inputs"
                                                input={Inputs.benefits_id}
                                                option={{source: 'db', data: Masterbase?.benefits}}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />
                                        </Col>  
                                    </Row> 

                                    <Row>
                                        <Col md={3} className="mb-3">{util.formatLabel('4. ตอบสนองต่อ', Inputs.target_industries_id)}</Col>
                                        <Col md={6} className="mb-3">
                                            <CommonSelect
                                                element="Inputs"
                                                input={Inputs.target_industries_id}
                                                option={{source: 'db', data: Masterbase?.target_industries}}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            /> 
                                        </Col>
                                    </Row> 

                                    <Row>
                                        <Col md={3} className="mb-3">{util.formatLabel('5. ', Inputs.batch_count)}</Col>
                                        <Col md={2} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.batch_count}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => { 
                                                    await onInputChange(e, element);
                                                    await this.calculateTotalPeople();
                                                    await this.calculateTotalBudget();
                                                }} 
                                            />  
                                        </Col>  
                                        <Col md={1} className="d-flex justify-content-between mb-3">
                                            {util.formatLabel(null, {label: 'รุ่น'})}
                                            {util.formatLabel(null, Inputs.people_per_batch)}
                                        </Col>
                                        <Col md={2} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.people_per_batch}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async(e, element) => {
                                                    await onInputChange(e, element);
                                                    await this.calculateTotalPeople();                                                    
                                                }} 
                                            />
                                        </Col> 
                                        <Col md={1} className="d-flex justify-content-end mb-3">{util.formatLabel(null, Inputs.total_people)}</Col>   
                                        <Col md={2} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.total_people}
                                                hr={false}
                                                disabled={true}
                                                floatingLabel={false}
                                            />   
                                        </Col> 
                                        <Col md={1} className="mb-3">{util.formatLabel(null, {label: 'คน'})}</Col> 
                                    </Row>

                                    <Row>
                                        <Col md={3} className="mb-3">{util.formatLabel('6. ', {label: 'กำหนดการฝึกอบรม', validator: {required: true}})}</Col>
                                        <Col md={2} className="mb-3">
                                            <CommonSelect
                                                element="Inputs"
                                                input={Inputs.training_start_month}
                                                option={{source: 'options', section: 'months', item: 'default'}}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />
                                        </Col>
                                        <Col md={2} className="mb-3">
                                            <CommonSelect
                                                element="Inputs"
                                                input={Inputs.training_start_year}
                                                option={{source: 'db', data: Masterbase?.yearBEOptions}}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={(e, element) => onInputChange(e, element)}
                                            />  
                                        </Col>
                                        <Col md={1} className="d-flex justify-content-center mb-3">
                                            {util.formatLabel(null, {label: 'ถึง', validator: {required: true}})}
                                        </Col>
                                        <Col md={2} className="mb-3">
                                            <CommonSelect
                                                element="Inputs"
                                                input={Inputs.training_end_month}
                                                option={{source: 'options', section: 'months', item: 'default'}}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />
                                        </Col>
                                        <Col md={2} className="mb-3">
                                            <CommonSelect
                                                element="Inputs"
                                                input={Inputs.training_end_year}
                                                option={{source: 'db', data: Masterbase?.yearBEOptions}}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={(e, element) => onInputChange(e, element)}
                                            />  
                                        </Col>  
                                    </Row>

                                    <Row>
                                        <Col md={3} className="mb-3">{util.formatLabel('7. ', Inputs.training_duration)}</Col>
                                        <Col md={2} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.training_duration}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />  
                                        </Col>
                                    </Row>  

                                    <Row>
                                        <Col md={3} className="mb-3">{util.formatLabel('8. ', Inputs.budget_per_batch)}</Col>
                                        <Col md={2} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.budget_per_batch}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => { 
                                                    await onInputChange(e, element);
                                                    await this.calculateTotalBudget();
                                                }} 
                                            />  
                                        </Col>  
                                        <Col md={1} className="mb-3">{util.formatLabel(null, {label: 'บาท'})}</Col>  
                                    </Row> 

                                    <Row>
                                        <Col md={3} className="d-flex justify-content-end mb-3">{util.formatLabel(null, Inputs.total_budget)}</Col>
                                        <Col md={2} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.total_budget}
                                                hr={false}
                                                floatingLabel={false}
                                                disabled={true}
                                            />
                                        </Col> 
                                        <Col md={1} className="mb-3">{util.formatLabel(null, {label: 'บาท'})}</Col>  
                                    </Row> 

                                    <Row>
                                        <Col md={{ span: 12, offset: 0 }} className="mb-3">
                                            <InlineEB01DataExpensesEB01 
                                                fkId="course_eb_01_id"
                                                fkVal={Inputs.id.value}
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={3} className="mb-3">{util.formatLabel('9. ', Inputs.target_group)}</Col>   
                                        <Col md={9} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.target_group}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />  
                                        </Col>
                                    </Row>   

                                    <Row>
                                        <Col md={3} className="mb-3">{util.formatLabel('10. ', Inputs.course_importance)}</Col>   
                                    </Row>

                                    <Row>
                                        <Col md={12} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.course_importance}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />  
                                        </Col>   
                                    </Row>  

                                    <Row>
                                        <Col md={12} className="mb-3">{util.formatLabel('11. ', {label: 'ผลลัพธ์การเรียนรู้ของหลักสูตร (Learning Outcomes)', validator: {required: true}})}</Col>   
                                    </Row>
                                    <Row>
                                        <Col md={{ span: 12, offset: 0 }} className="mb-3">
                                            <InlineEB01DataLearningResult
                                                fkId="course_eb_01_id"
                                                fkVal={Inputs.id.value}
                                            />
                                        </Col>
                                    </Row>
    
                                    <Row>
                                        <Col md={12} className="mb-3">{util.formatLabel('12. ', {label: 'ผลกระทบและประโยชน์ที่คาดว่าจะได้รับ (Impact)', validator: {required: true}})}</Col>   
                                    </Row> 
                                    <Row>
                                        <Col md={{ span: 12, offset: 0 }} className="mb-3">
                                            <InlineEB01DataCourseBenefit
                                                fkId="course_eb_01_id"
                                                fkVal={Inputs.id.value}
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={12} className="mb-3">{util.formatLabel('13. ', {label: 'รายละเอียดการฝึกอบรม', validator: {required: true}})}</Col>   
                                    </Row> 
                                    <Row>
                                        <Col md={{ span: 12, offset: 0 }} className="mb-3">
                                            <InlineEB01DataTrainingDetails
                                                fkId="course_eb_01_id"
                                                fkVal={Inputs.id.value}
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={12} className="mb-3">
                                            <label className="form-label">คำรับรองของสถานศึกษา</label>
                                            <ul className="text-list">
                                                <li><label className="form-label">1. ข้าพเจ้าขอรับรองว่า ข้อความในเอกสารฉบับนี้รวมถึงเอกสารหลักฐานที่ถูกอ้างถึงมีความถูกต้องและเป็นจริงทุกประการ</label></li>
                                                <li><label className="form-label">2. เมื่อได้รับการรับรองหลักสูตรแล้วสถานศึกษาจะมีการจัดทำข้อตกลงกับสถานประกอบการที่ส่งบุคลากรมาฝึกอบรมในการรับหรือให้บุคลากรเข้าทำงานในสถานประกอบการ</label></li>
                                            </ul>
                                        </Col>
                                    </Row>   

                                    <Row>
                                        <Col md={3} className="mb-3">{util.formatLabel(null, {label: 'สถานศึกษาผู้รับผิดชอบหลักสูตร', validator: {required: false}})}</Col> 
                                        <Col md={2} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.academy_signer_name}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />  
                                        </Col>   
                                        <Col md={1} className="mb-3">{util.formatLabel(null, {label: 'ตำแหน่ง', validator: {required: false}})}</Col>
                                        <Col md={2} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.academy_signer_position}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />  
                                        </Col>
                                        <Col md={1} className="mb-3">{util.formatLabel(null, {label: 'วันที่', validator: {required: false}})}</Col>
                                        <Col md={2} className="mb-3">
                                            <CustomDatePicker
                                                element="Inputs"
                                                input={Inputs.academy_sign_date}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={3} className="mb-3">{util.formatLabel(null, {label: 'ผู้ประกอบการที่ร่วมรับรอง', validator: {required: false}})}</Col> 
                                        <Col md={2} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.enterprise_signer_name}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />  
                                        </Col>   
                                        <Col md={1} className="mb-3">{util.formatLabel(null, {label: 'ตำแหน่ง', validator: {required: false}})}</Col>
                                        <Col md={2} className="mb-3">
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.enterprise_signer_position}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />  
                                        </Col>
                                        <Col md={1} className="mb-3">{util.formatLabel(null, {label: 'วันที่', validator: {required: false}})}</Col>
                                        <Col md={2} className="mb-3">
                                            <CustomDatePicker
                                                element="Inputs"
                                                input={Inputs.enterprise_sign_date}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />
                                        </Col>
                                    </Row> 
                                    <Row>
                                        <Col md={3} className="mb-3">{util.formatLabel(null, {label: 'เอกสารการรับรอง', validator: {required: false}})}</Col> 
                                        {/* <Col md={4} className="mb-3">{util.formatLabel('', Inputs.approve_file, '', 'sm')}</Col>*/}
                                        <Col md={8} className="mb-3">
                                            <CommonFile
                                                element="Inputs"
                                                input={Inputs.approve_file}
                                                // size="sm"
                                                hr={false}
                                                floatingLabel={false}                                                
                                                callback={(e, element) => onInputChange(e, element)} 
                                                
                                                previewFile={(e) => onPreviewFile(e)} 
                                                deleteFile={(e) => onDeleteFile(e, Inputs.id)} 
                                                // callback={(e, element) => Actions.handleInputChange(this.updateState, element, e)} 
                                                // previewFile={(e) => Actions.handlePreviewFile(this.updateState, e)} 
                                                // deleteFile={(field, pk) =>  Actions.deleteFile(this.updateState, URL, field, Inputs.id)} 
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md={12}>
                                            <hr className="hr-custom" />
                                        </Col>
                                    </Row>

                                    <Row className="mt-3">
                                        <Col md={3}>
                                            <i className="text-primary fa-classic fa-solid fa-arrow-progress fa-fw me-2"></i>
                                            {util.formatLabel(null, {label: 'การดำเนินงาน', validator: {required: true}})}
                                        </Col> 
                                        <Col md={5}>
                                            <CommonSelect
                                                element="Inputs"
                                                input={Inputs.operation}
                                                option={{source: 'options', section: 'status', item: 'eb01_course_operation_status'}}
                                                hr={false}
                                                floatingLabel={false}
                                                callback={async (e, element) => { 
                                                    await onInputChange(e, element);
                                                    await this.resetApproveCourse(e);
                                                }} 
                                                disabled={!['0','1','2'].includes(UserCookie?.types)}
                                            />  
                                        </Col>
                                        {(console.log(UserCookie?.types))}
                                    </Row>
                                    {Inputs.operation.value === '1' && (
                                        <Row className="mt-3">
                                            <Col md={3} className="mb-3">
                                                <i className="text-warning fa-classic fa-solid fa-message-question fa-fw me-2"></i>
                                                {util.formatLabel(null, {label: 'สำนักพิจารณาให้แก้ไข', validator: {required: false}})}
                                            </Col> 
                                            <Col md={5} className="mb-3">
                                                <CommonInput
                                                    element="Inputs"
                                                    input={Inputs.operation_comment}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                    disabled={!['0','1'].includes(UserCookie?.types)}
                                                />
                                            </Col>
                                        </Row>  
                                    )}

                                    {Inputs.operation.value === '3' && (
                                        <>
                                        {['0','1'].includes(UserCookie?.types) && (
                                            <>
                                            <Row>
                                                <Col md={12}>
                                                    <hr className="hr-custom" />
                                                </Col>
                                            </Row>   

                                            <Row className="mt-3">
                                                <Col md={3} className="mb-3">
                                                    <i className="text-success fa-classic fa-solid fa-user fa-fw me-2"></i>
                                                    {util.formatLabel(null, {label: 'สำหรับเจ้าหน้าที่', validator: {required: false}})}
                                                </Col> 
                                                <Col md={5} className="mb-3">
                                                    <CommonSelect
                                                        element="Inputs"
                                                        input={Inputs.status}
                                                        option={{source: 'options', section: 'status', item: 'eb01_course_approve_status'}}
                                                        hr={false}
                                                        floatingLabel={false}
                                                        callback={(e, element) => onInputChange(e, element)} 
                                                    />  
                                                </Col>
                                            </Row>

                                            {Inputs.status.value === '1' && (
                                                <Row>
                                                    <Col md={3} className="mb-3">
                                                        <i className="text-info fa-classic fa-solid fa-message-quote fa-fw me-2"></i>
                                                        {util.formatLabel(null, {label: 'เงื่อนไขการรับรองหลักสูตร', validator: {required: false}})}
                                                    </Col> 
                                                    <Col md={5} className="mb-3">
                                                        <CommonInput
                                                            element="Inputs"
                                                            input={Inputs.approve_condition}
                                                            hr={false}
                                                            floatingLabel={false}
                                                            callback={(e, element) => onInputChange(e, element)} 
                                                        />
                                                    </Col>
                                                </Row>  
                                            )}
                                        
                                            <Row>
                                                <Col md={3} className="d-flex align-items-center justify-content-end mb-3">
                                                    {util.formatLabel(null, {label: 'ลงชื่อ', validator: {required: false}})}
                                                </Col>
                                                <Col md={2} className="mb-3">
                                                    <CommonInput
                                                        element="Inputs"
                                                        input={Inputs.office_signer_name}
                                                        hr={false}
                                                        floatingLabel={false}
                                                        callback={(e, element) => onInputChange(e, element)} 
                                                    />   
                                                </Col>
                                                <Col md={1} className="mb-3 text-end">
                                                    {util.formatLabel(null, {label: 'วันที่', validator: {required: false}})}
                                                </Col>
                                                <Col md={2} className="mb-3">
                                                <CustomDatePicker
                                                    element="Inputs"
                                                    input={Inputs.office_sign_date}
                                                    hr={false}
                                                    floatingLabel={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                />
                                                </Col>
                                            </Row>
                                            </>
                                        )}
                                        </>
                                    )}   
                                    
                                    <Row  ref={this.approvedRef}><Col md={12}></Col></Row>

                                </Col>
                            </Row>
                        </Container>
                         
                    </SimpleBar>

                </Offcanvas.Body>

                <div className="offcanvas-footer d-flex flex-column border-top bg-light p-3">

                    <CommonLoadingBar isLoading={isLoading} />

                    <div className="d-flex justify-content-end mt-2">
                        <CommonButton 
                            task={mode} 
                            disabled={isLoading ? true : Submit ? false : true}
                            callback={async (e) => {
                                await onSubmit(e);
                                if(Action.Mode === 'update' && ['0', '1'].includes(Inputs.status.value)){
                                    await new Promise(resolve => setTimeout(resolve, 1000));
                                    await onGenerateCourseCode({id: Inputs.id.value})
                                }
                            }} 
                        />

                        {Action.Mode === 'new' && (
                            <CommonButton 
                                task="discard" 
                                inlineClass="ms-1" 
                                disabled={isLoading} 
                                callback={(e) => onDiscardSubmit(false)} 
                            />
                        )}
                    </div>
                </div>
            </Offcanvas>
        )
    }
}

export default InputEB01DataCourse;